const interval = 30; // Sync interval in seconds
const onClockTime = true; // Sync interval to clock time (ie. on minute and half minute)

export type SyncCallback = () => void;

export default class SyncService {
    private callbacks: SyncCallback[] = [];
    private timer: any;

    constructor() {
        this.start();
    }

    register(callback: SyncCallback): SyncCallback {
        const found = this.callbacks.indexOf(callback);
        if (found === -1) {
            this.callbacks.push(callback);
        }
        return callback;
    }

    unregister(callback: SyncCallback): void {
        const found = this.callbacks.indexOf(callback);
        if (found !== -1) {
            this.callbacks.splice(found, 1);
        }
    }

    private notify() {
        let x = this.callbacks.length;
        while (x--) {
            this.callbacks[x]();
        }
    }

    private start() {
        if (!onClockTime) {
            setInterval(() => {
                this.notify();
            }, interval * 1000);
        } else if (!this.timer) {
            // Sync the update to happen on clock time.  Needed by Command Centers.
            const seconds = new Date().getSeconds();
            const remaining = seconds % interval;
            const delay = interval - remaining;

            // If too close, then wait another full interval
            // if (delay <= prefetchBeforeNotify + 1) {
            //     delay += interval;
            // }

            this.timer = setTimeout(() => {
                this.notify();

                // startNotifyTimer();

                // Start timer again
                this.timer = null;
                this.start();
            }, delay /* - prefetchBeforeNotify */ * 1000);
        }
    }
}
